import { Suspense, useState, useEffect } from 'react';
import { AppProviders } from './providers/AppProviders';
import { AppRouter } from './routes';
import { LoadingSpinner } from './components/LoadingSpinner';
import { OfflineBanner } from './components/OfflineBanner';
import { UpdateToast } from './components/UpdateToast';

export function App() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    const handleSwUpdate = () => setUpdateAvailable(true);
    window.addEventListener('sw-update-available', handleSwUpdate);
    return () => {
      window.removeEventListener('sw-update-available', handleSwUpdate);
    };
  }, []);

  const handleApplyUpdate = () => {
    window.location.reload();
  };

  return (
    <AppProviders>
      <OfflineBanner isOnline={isOnline} />
      <Suspense fallback={<LoadingSpinner />}>
        <AppRouter />
      </Suspense>
      <UpdateToast updateAvailable={updateAvailable} onApplyUpdate={handleApplyUpdate} />
    </AppProviders>
  );
}
